import { useAtomValue } from 'jotai';
import { getPatientMostRecentDealAtom } from '../../store/global/atoms';

export const useGetPatientMostRecentDeal = () => {
  const getPatientDealsBase = useAtomValue(getPatientMostRecentDealAtom);

  return {
    patientDeals: getPatientDealsBase.data,
    getPatientMostRecentDeal: getPatientDealsBase.mutate,
    getPatientMostRecentDealAsync: getPatientDealsBase.mutateAsync,
    isLoading: getPatientDealsBase.isPending,
    isError: getPatientDealsBase.isError,
  };
};
